import { defineComponent as _defineComponent } from 'vue'

import type { OpenEndedQuestion } from '@ilteducation/exercise-service-types';

type Props = {
  item: OpenEndedQuestion;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowOpenEnded',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: OpenEndedQuestion;
}



return { __sfc: true,props }
}

})